export const INVOICE_PREFIX_CHARACTER_LIMIT = 8
